<template>
  <div v-if="items.length > 0">
    <div class="section-header section-header--non-stacking w-full show-for-large mb-2">
      <div class="heading font-body font-medium" qaid="selectedText">{{ bp('selected') }}</div>
      <div
        v-show="items.length > 0"
        class="cursor-pointer font-normal text-sm my-0"
        qaid="clearAllLink"
        @click="clearFilters"
      >
        {{ bp('clearSelections') }}
      </div>
    </div>
    <ul class="facet-group__list">
      <li v-for="(filter, i) in items" :key="`filter-${i}`" class="facet-group__list-item mb-25 is-active">
        <form class="flex justify-between label-selected">
          <label class="flex-grow pl-1">
            <em v-html="getLabelText(filter)"></em>
          </label>
          <div class="flex items-center pr-1 cursor-pointer">
            <i class="material-icons md-18" :qaid="`clearFilter${i}`" @click.prevent="clearFilter(filter, i)">cancel</i>
          </div>
        </form>
      </li>
    </ul>
    <trek-button secondary block class="hide-for-large mt-2" qaid="clearAllLink" @click="clearFilters">
      <span v-html="bp('clearSelections')"></span>
    </trek-button>
  </div>
</template>
<script>
import get from 'lodash/get';
import TrekButton from '@/components/TrekButton';

export default {
  name: 'SelectedFilters',
  components: {TrekButton},
  props: {
    filters: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  watch: {
    filters: {
      deep: true,
      handler(value) {
        this.items = value;
      },
    },
  },
  mounted() {
    this.items = this.filters;
  },
  methods: {
    getLabelText(filter) {
      return get(filter, 'facetOptionsValueDataList[0].displayText', '');
    },
    clearFilters() {
      this.items.forEach((item) => {
        item.selected = true;
      });
      this.$emit('state-changed', this.items);
      this.items = [];
    },
    clearFilter(filter, index) {
      filter.selected = true;
      this.items.splice(index, 1);
      this.$emit('state-changed', filter);
    },
  },
};
</script>
